export class UserRoles {
  public static readonly COMPLIANCE_ONLY_ROLES = {
    tpsafeuser: true,
    repouser: true
  };
}
